import { Header, Stack, styled } from '@lessonnine/design-system.lib';
import PropTypes from 'prop-types';
// External Imports
import React from 'react';
import { connect } from 'react-redux';

import { ToggleContainerConsumer } from '../../../context/toggleContainer.mjs';
import { selectLanguage } from '../../../selectors/selectMatch.mjs';
// Internal Imports
import { selectNavigationText } from '../../../selectors/selectNavigationText.mjs';
import { I18n } from '../../I18n/I18n.jsx';
import { NavBarLink } from '../../Link/NavBarLink.jsx';
import { buildExploreLink } from './buildExploreLink.mjs';

const StyledNavBarLink = styled(NavBarLink)`
  color: ${({ theme }) => theme.color.surface.foreground.primary};
`;

// Component Definition
function MobileNavExploreBase({ language, navigationTextObj }) {
  return (
    <ToggleContainerConsumer>
      {({ close: closeContainer }) => (
        <Stack gap={33}>
          {navigationTextObj.categories?.length > 0 ? (
            // TODO [redesign]: remove Stack when SSR gap rendering is fixed in the design system
            <Stack gap={20}>
              {/* eslint-disable-next-line react/jsx-pascal-case -- API of the design-system */}
              <Header.h3>
                <I18n defaultText="Explore" field="categories" />
              </Header.h3>
              <Stack as="ul">
                {navigationTextObj.categories.map((link) => (
                  <li key={link.label}>
                    <StyledNavBarLink
                      key={link.label}
                      link={link}
                      onClick={closeContainer}
                      to={buildExploreLink({
                        langCode: language,
                        link,
                        urlPrefix: 'category',
                      })}
                    >
                      {link.label}
                    </StyledNavBarLink>
                  </li>
                ))}
              </Stack>
            </Stack>
          ) : undefined}
          {navigationTextObj.aboutLanguages?.length > 0 ? (
            // TODO [redesign]: remove Stack when SSR gap rendering is fixed in the design system
            <Stack gap={20}>
              {/* eslint-disable-next-line react/jsx-pascal-case -- API of the design-system */}
              <Header.h3>
                <I18n defaultText="Articles About" field="articles-about" />
              </Header.h3>
              <Stack as="ul">
                {navigationTextObj.aboutLanguages.map((link) => (
                  <li key={link.label}>
                    <NavBarLink
                      key={link.label}
                      link={link}
                      onClick={closeContainer}
                      to={buildExploreLink({
                        langCode: language,
                        link,
                        urlPrefix: 'tags',
                      })}
                    >
                      {link.label}
                    </NavBarLink>
                  </li>
                ))}
              </Stack>
            </Stack>
          ) : undefined}
        </Stack>
      )}
    </ToggleContainerConsumer>
  );
}

MobileNavExploreBase.propTypes = {
  language: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types -- fix when migrating to TS
  navigationTextObj: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  language: selectLanguage(state),
  navigationTextObj: selectNavigationText(state),
});

const withRedux = connect(mapStateToProps);

const MobileNavExplore = withRedux(MobileNavExploreBase);

// Module Exports
export { MobileNavExplore };
